import useUserData from 'hooks/useUserData';
import _, { compact } from 'lodash';
import { useCallback, useMemo } from 'react';
import { GetAdditionalFiltersOptions, useConfigFilters } from '@buildwise/libs/configurations';
import { ConfigEntryType } from 'config/config';
import { InsightSummaryStatusType } from '../queries/useInsightsSummaryQuery';
import { useLocation } from 'react-router-dom';
import { renderInsightStatusOptionLabel, renderInsightTypeOptionLabel } from '../helpers';
import { INDUSTRY_INSIGHTS } from '../constants';

function useInsightsFilters({ insightsModule }: { insightsModule: ConfigEntryType | undefined }) {
  const { pathname } = useLocation();
  const { companyId, isNovaOrCompanyAdmin } = useUserData();
  const getAdditionalFilters = useCallback(
    ({ configFilters }: GetAdditionalFiltersOptions) => {
      return compact(
        configFilters.map((filter) => {
          if (filter.category === 'status') {
            return !pathname.includes('project')
              ? {
                  ...filter,
                  options: filter.options.map((option) => ({
                    ...option,
                    label:
                      typeof option.value === 'string'
                        ? renderInsightStatusOptionLabel(option.value as InsightSummaryStatusType)
                        : option.label,
                  })),
                  showSelectAll: false,
                }
              : undefined;
          }

          if (filter.category === 'insightType') {
            return pathname.includes('project')
              ? {
                  ...filter,
                  options: filter.options.map((option) => ({
                    ...option,
                    label:
                      typeof option.value === 'string'
                        ? renderInsightTypeOptionLabel(option.value)
                        : option.label,
                  })),
                  selectedOptions: [INDUSTRY_INSIGHTS],
                  showSelectAll: false,
                }
              : undefined;
          }

          return filter;
        }),
      );
    },
    [isNovaOrCompanyAdmin, pathname],
  );
  const { filters, isFiltersLoading, setFilters, clearFilters } = useConfigFilters({
    companyId,
    configName: insightsModule?.referenceObject?.filterBy?.configRefName || '',
    shouldFetch:
      insightsModule?.referenceObject?.filterBy?.isActive ||
      insightsModule?.referenceObject?.filterBy?.isActive === undefined,
    getAdditionalFilters,
  });
  // const { pathname } = useLocation();
  // const { configsValues, configsQueryResponse } = useMultiCompanyConfigQuery({
  //   configs: ['PROJECT_PHASES', 'REGIONS'],
  // });
  // const {
  //   filters: { [companyId]: { filters: filtersFromStore = [] } = {} },
  //   resetFilters: resetInsightsFiltersStore,
  //   setFilters: setInsightsFiltersStore,
  // } = useInsightsFiltersStore();
  const hasActiveFilters = useMemo(
    () =>
      filters.filter((filter) =>
        filter.inputType === 'radio'
          ? filter.selectedValue !== filter.defaultSelectedValue
          : filter.selectedOptions && filter.selectedOptions?.length > 0,
      ).length > 0,
    [filters],
  );

  // function getMappedFilters(prevState?: FilterType[]): FilterType[] {
  //   const phasesOptions = JSON.parse(configsOptions)?.['PROJECT_PHASES'] || [];
  //   const regionsOptions = JSON.parse(configsOptions)?.['REGIONS'] || [];
  //   const defaultDateSelectedValue =
  //     DATE_FILTERS.find((option) => option.value === 'All')?.value || '';

  //   return _.compact([
  //     {
  //       category: 'projectPhases',
  //       categoryIndex: 0,
  //       displayName: 'Phases',
  //       options: phasesOptions.map((option) => ({
  //         label: option,
  //         value: option,
  //       })),
  //       allOptions: phasesOptions,
  //       selectedOptions:
  //         (filtersFromStore.find((_filter) => _filter.filterName === 'projectPhases')
  //           ?.filterValues as string[]) ||
  //         prevState?.[0]?.selectedOptions ||
  //         [],
  //       onChange: handleFilterChange.bind(null, 0),
  //       showSelectAll: true,
  //     },
  //     {
  //       category: 'regions',
  //       categoryIndex: 1,
  //       displayName: 'Regions',
  //       options: regionsOptions.map((option) => ({
  //         label: option,
  //         value: option,
  //       })),
  //       allOptions: regionsOptions,
  //       selectedOptions:
  //         (filtersFromStore.find((_filter) => _filter.filterName === 'regions')
  //           ?.filterValues as string[]) ||
  //         prevState?.[1]?.selectedOptions ||
  //         [],
  //       onChange: handleFilterChange.bind(null, 1),
  //       showSelectAll: true,
  //     },
  //     {
  //       category: 'date',
  //       categoryIndex: 2,
  //       displayName: 'Date',
  //       options: DATE_FILTERS.map((option) => ({
  //         label: option.label,
  //         value: option.value,
  //       })),
  //       allOptions: DATE_FILTERS.map((option) => option.value),
  //       inputType: 'radio',
  //       selectedOptions:
  //         (filtersFromStore.find((_filter) => _filter.filterName === 'date')
  //           ?.filterValues as string[]) ||
  //         prevState?.[2]?.selectedOptions ||
  //         [],
  //       selectedValue: prevState?.[2]?.selectedValue || defaultDateSelectedValue,
  //       defaultSelectedValue: defaultDateSelectedValue,
  //       onRadioChange: handleRadioChange.bind(null, 2),
  //       showSelectAll: false,
  //     },
  //     // pathname.includes('project') && {
  //     //   category: 'Insight Type',
  //     //   categoryIndex: 3,
  //     //   options: [
  //     //     {
  //     //       label: (
  //     //         <>
  //     //           <Box
  //     //             component="span"
  //     //             sx={(theme) => ({ color: theme.palette.custom.brown })}
  //     //             ml={0.5}
  //     //             display="flex"
  //     //             alignItems="center"
  //     //           >
  //     //             <BuildWiseInsightsBadge>
  //     //               <LightbulbFillIcon size={20} color={theme.palette.custom.pirateGold} />
  //     //               &nbsp;Industry Insights
  //     //             </BuildWiseInsightsBadge>
  //     //           </Box>
  //     //         </>
  //     //       ),
  //     //       value: 'Industry Insights',
  //     //     },
  //     //   ],
  //     //   allOptions: ['Industry Insights'],
  //     //   selectedOptions: ['Industry Insights'],
  //     //   onChange: handleFilterChange.bind(null, 3),
  //     //   showSelectAll: false,
  //     // },
  //     isNovaOrCompanyAdmin &&
  //       !pathname.includes('project') && {
  //         category: 'Status',
  //         categoryIndex: 3,
  //         options: [
  //           {
  //             label: (
  //               <InsightStatusChip className="review-pending">
  //                 <TimeLineIcon size={20} color={theme.palette.custom.tuna} />
  //                 <InsightStatusText>Review Pending</InsightStatusText>
  //               </InsightStatusChip>
  //             ),
  //             value: 'REVIEW_PENDING',
  //           },
  //           {
  //             label: (
  //               <InsightStatusChip className="published">
  //                 <CheckLineIcon size={20} color={theme.palette.custom.tuna} />
  //                 <InsightStatusText>Published</InsightStatusText>
  //               </InsightStatusChip>
  //             ),
  //             value: 'PUBLISHED',
  //           },
  //         ],
  //         allOptions: ['REVIEW_PENDING', 'PUBLISHED'],
  //         selectedOptions: prevState?.[3]?.selectedOptions || [],
  //         onChange: handleFilterChange.bind(null, 3),
  //         showSelectAll: false,
  //       },
  //   ]);
  // }

  // function handleRadioChange(categoryIndex: number, event: ChangeEvent<HTMLInputElement>) {
  //   setFilters((prevState) => {
  //     const updatedState = [...prevState];

  //     if (event.target.checked) {
  //       updatedState[categoryIndex].selectedValue = event.target.value;
  //     }

  //     setInsightsFiltersStore({
  //       companyId,
  //       filters: _.uniqBy(
  //         [
  //           ...updatedState.map((filter) => ({
  //             filterName: filter?.category || '',
  //             filterValues: filter?.selectedOptions || [],
  //           })),
  //           ...filtersFromStore,
  //         ],
  //         'filterName',
  //       ),
  //     });
  //     return updatedState;
  //   });
  // }

  // function handleFilterChange(
  //   categoryIndex: number,
  //   event: ChangeEvent<HTMLInputElement>,
  //   checked: boolean,
  // ) {
  //   setFilters((prevState) => {
  //     const updatedState = [...prevState];

  //     if (event.target.value === 'Select All') {
  //       if (checked) {
  //         updatedState[categoryIndex].selectedOptions = updatedState[categoryIndex].allOptions;
  //       } else {
  //         updatedState[categoryIndex].selectedOptions = [];
  //       }
  //     } else {
  //       if (checked) {
  //         updatedState[categoryIndex].selectedOptions = [
  //           ...(updatedState[categoryIndex]?.selectedOptions || []),
  //           event.target.value,
  //         ];
  //       } else {
  //         updatedState[categoryIndex].selectedOptions = updatedState[
  //           categoryIndex
  //         ]?.selectedOptions?.filter((option) => option !== event.target.value);
  //       }
  //     }

  //     setInsightsFiltersStore({
  //       companyId,
  //       filters: _.uniqBy(
  //         [
  //           ...updatedState.map((filter) => ({
  //             filterName: filter?.category || '',
  //             filterValues: filter?.selectedOptions || [],
  //           })),
  //           ...filtersFromStore,
  //         ],
  //         'filterName',
  //       ),
  //     });

  //     return updatedState;
  //   });
  // }

  // const clearFilters = () => {
  //   setFilters((prevState) => {
  //     return prevState.map((filter) => ({
  //       ...filter,
  //       selectedOptions: [],
  //       selectedValue: filter.defaultSelectedValue,
  //       defaultSelectedValue: filter.defaultSelectedValue,
  //     }));
  //   });
  //   resetInsightsFiltersStore({
  //     companyId,
  //   });
  // };

  return {
    hasActiveFilters,
    isFiltersLoading,
    filters,
    clearFilters,
    setFilters,
  };
}

export default useInsightsFilters;
